import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';

@Injectable({
    providedIn: 'root'
})
export class ReportService {

    constructor(private apiService: ApiService) {
    }

    public getAssignmentReport(userId, selectedYear: number) {
        return this.apiService.getCallData$<any[]>('users/assignmentReport',
            {
                userId: userId,
                year: selectedYear
            });
    }
}
